import { Link } from 'react-router-dom';


const Login = () => {
  return (
    <>
      <div className="login_wrap">
        <div className="login_header">
          <span>나에게 가장 가까운</span>
          <span> 인생 미용실 찾기 </span>
          <div className="login_logo">
            <img src='https://kimsikyoung.github.io/images/HaiRound/logo/hairound_Wlogo.png' width={200} height={50} alt='logo'></img>
          </div>
        </div>
        <div className="login_contents">
          <div className="content_header">
            LOGIN
          </div>
          <input className="login_input" placeholder="아이디, 이메일, 전화번호">
          </input>
          <input className="login_input" placeholder="비밀번호">
          </input>
          <Link to="/Main" className='login_text_box'>
            로그인
          </Link>
          <div className='login_membership'>
            <span className='sp_left'>회원가입</span>
            <span className='sp_right'>계정찾기 &nbsp; 비밀번호찾기</span>
          </div>
          <div className='sns'>
            <img src='https://kimsikyoung.github.io/images/HaiRound/img/sns.png' alt='logo'></img>
          </div>
          <div className="login_copy">
            Copyright &copy; hairound Corp. All rights reserved.
          </div>
        </div>
      </div>
    </>
  )
};

export default Login;